<template>
  <ManagerHRTimesheetCard
    v-if="isHrTimesheetCard"
    :sheet="sheet"
    @edit="$emit('edit', $event)"
    @open-attachment="$emit('open-attachment', $event)"
  />
  <ManagerConsultantTimesheetCard
    v-else
    :sheet="sheet"
    @edit="$emit('edit', $event)"
    @open-attachment="$emit('open-attachment', $event)"
  />
</template>

<script>
import ManagerHRTimesheetCard from './ManagerHRTimesheetCard.vue';
import ManagerConsultantTimesheetCard from './ManagerConsultantTimesheetCard.vue';

/**
 * Router entry: picks HR vs consultant card. Reuse ManagerHRTimesheetCard or
 * ManagerConsultantTimesheetCard directly when the list type is fixed.
 */
export default {
  name: 'ManagerTimesheetCard',
  components: {
    ManagerHRTimesheetCard,
    ManagerConsultantTimesheetCard
  },
  props: {
    sheet: {
      type: Object,
      required: true
    }
  },
  emits: ['edit', 'open-attachment'],
  computed: {
    isHrTimesheetCard() {
      return (this.sheet && this.sheet.listSource) === 'hr';
    }
  }
};
</script>
